// extracted by mini-css-extract-plugin
export default {"container":"InfoBlock_container__AKR8y","data":"InfoBlock_data__n-f-3","secondary":"InfoBlock_secondary__IBDll","title":"InfoBlock_title__v4c-D"};